import { render, staticRenderFns } from "./SignUpStepPassword.vue?vue&type=template&id=12c1c861"
import script from "./SignUpStepPassword.vue?vue&type=script&lang=js"
export * from "./SignUpStepPassword.vue?vue&type=script&lang=js"
import style0 from "./SignUpStepPassword.vue?vue&type=style&index=0&id=12c1c861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports